<div class="window-wrapper">
    <div class="paired-container" [class.hidden]="isLoading">
        <div class="ui selection dropdown time-range-start" #timeRangeStartDropdown>
            <input type="hidden" name="time-range-start" />
            <i class="dropdown icon"></i>
            <div class="default text">Start</div>
            <div class="menu">
                <div
                    class="item"
                    *ngFor="let startTime of timeIntervals | timeAfter: minStartHour:30"
                    [attr.data-value]="startTime.value"
                >
                    {{ startTime.name }}
                </div>
            </div>
        </div>
        <div class="divider">to</div>
        <div class="ui selection dropdown time-range-end" id="timeRangeEnd" #timeRangeEndDropdown>
            <input type="hidden" name="timeEnd" />
            <i class="dropdown icon"></i>
            <div class="default text">End</div>
        </div>
    </div>
    <button *ngIf="index > 0" class="ui icon mini button" (click)="handleRemoveTimeRange()">
        <i class="times icon"></i>
    </button>
</div>
<div *ngIf="error" class="warning">{{ error }}</div>
